import i18n from '../../../../../i18n'

const SECTION_LABELS = {
  updates: 'sections.updates',
  schedule: 'sections.schedule',
  courseBrief: 'sections.courseBrief',
  courseMap: 'sections.courseMap',
  checkpointsGuide: 'sections.checkpointsGuide',
  mandatoryGear: 'sections.mandatoryGear',
  recommendedGear: 'sections.recommendedGear',
  travelAndParking: 'sections.travelAndParking',
  dropBagInfo: 'sections.dropBagInfo',
  finishPrizes: 'sections.finishPrizes',
  aidStationInfo: 'sections.aidStationInfo',
  raceVenueInfo: 'sections.raceVenueInfo',
  raceInfo: 'sections.raceInfo',
  rulesAndPenalties: 'sections.rulesAndPenalties',
  trackingAndContacts: 'sections.trackingAndContacts',
  travelGuide: 'sections.travelGuide',
  sponsors: 'sections.sponsors'
}

// Single source of truth for the race guide accordion order and grouping.
// The admin editor renders its per-accordion toggles in this same order.
export const GUIDE_SECTION_GROUPS = [
  ['updates', 'schedule', 'courseBrief', 'courseMap', 'checkpointsGuide', 'mandatoryGear', 'recommendedGear', 'travelAndParking', 'dropBagInfo', 'finishPrizes'],
  ['aidStationInfo', 'raceVenueInfo', 'raceInfo', 'rulesAndPenalties', 'trackingAndContacts', 'travelGuide', 'sponsors']
]

export const GUIDE_SECTIONS = GUIDE_SECTION_GROUPS
  .flat()
  .map(id => ({
    id,
    labelKey: SECTION_LABELS[id],
    label: i18n.t(SECTION_LABELS[id], { ns: 'raceGuide' })
  }))

export const DEFAULT_GUIDE_SECTIONS = GUIDE_SECTIONS.reduce((acc, section) => {
  acc[section.id] = true
  return acc
}, {})

export function isSectionVisible (guideSections, id) {
  return guideSections?.[id] !== false
}
